import * as React from "react";
import { connect } from "react-redux";
import Modal from "../Modal";

import {isPc} from '../../utils/util';
import globalAction from '../../actions/global';
import './index.css';

class UpgradeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    
    componentDidMount() {
        
    }
    __onLoginOk(_username) {
        const { onLoginOk } = this.props;
        onLoginOk && onLoginOk(_username);
    }
    __onClose() {
        const {onClose} = this.props;
        onClose && onClose();
    }
    __handleSubmitAddr(drawRecordId) {
        const { submitAddr, setPhoneDrawRecordId } = this.props;
        submitAddr && submitAddr();
        // 手机的中奖id
        setPhoneDrawRecordId(drawRecordId);
    }
    handleClick() {
        const {confirmClick} = this.props;
        confirmClick && confirmClick();
    }
    renderContent(value, url) {
        let content = '';
        switch(value) {
            case 1:
                content = <img src={url} alt=""/>;
                break;
            case 2:
                content = <div className="m-myRecord-item__hdText"><span>8</span>元</div>;
                break;
            case 3:
                content = <div className="m-myRecord-item__hdText"><span>6</span>个月</div>;
                break;
            case 4:
                content = <div className="m-myRecord-item__hdText"><span>1</span>年</div>;
                break;
            case 5:
                content = <div className="w-mobile-pic"></div>;
                break;
            default:
                break;
        }
        return content;
    }
    renderDesc(data) {
        let content = '';
        switch(data.prizeId) {
            case 1:
                content = <p>微信扫码，添加班主任<br/>备注活动VIP帐号，即可入学</p>;
                break;
            case 2:
            case 3:
            case 4:
                content = <p>已加帐号上<br/>可在邮箱「个人中心」查看</p>
                break;
            case 5:
                content = <button className="w-button" onClick={() => {this.__handleSubmitAddr(data.drawRecordId)}}>填写收货地址</button>
                break;
            default:
                break;
        }
        return content;
    }
    render() {
        const {isOpen} = this.props;
        const isPcClient = isPc();

        return (
            <Modal isOpen={isOpen} title="本活动仅支持15元及以上套餐参与" className="w-upgrade-modal" onClose={this.__onClose.bind(this)}>
                <div>
                    <div className="m-upgradeModal-bd">
                        <div className="m-upgradeModal-desc">升级邮箱套餐，{!isPcClient && <br/>}突破参数限制，最高无限容量</div>
                        <ul className="f-clear">
                            <li>
                                <div className="m-upgradeItem-bd m-upgradeItem-bd-1"></div>
                                <div className="m-upgradeItem-ft">容量升级</div>
                            </li>
                            <li>
                                <div className="m-upgradeItem-bd m-upgradeItem-bd-2"></div>
                                <div className="m-upgradeItem-ft">网盘升级</div>
                            </li>
                            <li>
                                <div className="m-upgradeItem-bd m-upgradeItem-bd-3"></div>
                                <div className="m-upgradeItem-ft">附件升级</div>
                            </li>
                            <li className={isPcClient ? '' : 'hide'}>
                                <div className="m-upgradeItem-bd m-upgradeItem-bd-4"></div>
                                <div className="m-upgradeItem-ft">群发升级</div>
                            </li>
                            <li className={isPcClient ? '' : 'hide'}>
                                <div className="m-upgradeItem-bd m-upgradeItem-bd-5"></div>
                                <div className="m-upgradeItem-ft">服务升级</div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="m-upgradeModal-ft">
                    {
                        isPc() ?
                            <button className="w-button" onClick={this.handleClick.bind(this)}>升级套餐 赢Mate30 Pro</button>
                            :
                            <div className="m-upgradeModal-ft-text">
                                自助升级：进入网页版邮箱-个人中心-套餐升级<br/>
                                人工升级：拨打4009-163-163 进行人工升级套餐
                            </div>
                    }
                    
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state) {
    return {
        records: state.global.records,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setPhoneDrawRecordId(id) {
            dispatch(globalAction.setPhoneDrawRecordId(id));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UpgradeModal);
